import { DocumentType } from './DocumentType';

export const DocStatus = {
  OPENED: 'O',
  CLOSED: 'C',
  CANCELED: 'S',
  CANCELLATION: 'R',
  DELETED: 'D',
  PLANNED: 'P',
};

export const DocStatusList = [
  { label: 'Nyitott', value: DocStatus.OPENED },
  { label: 'Zárt', value: DocStatus.CLOSED },
  { label: 'Stornózott', value: DocStatus.CANCELED },
  { label: 'Stornó', value: DocStatus.CANCELLATION },
  { label: 'Törölt', value: DocStatus.DELETED },
  { label: 'Tervezett', value: DocStatus.PLANNED },
];

export const StatusColors = {
  [DocStatus.OPENED]: 'green',
  [DocStatus.CLOSED]: 'grey',
  [DocStatus.CANCELED]: 'red',
  [DocStatus.CANCELLATION]: 'red',
};

export const DocLineStatus = {
  OPENED: 'O',
  CLOSED: 'C',
};

export const Operation = {
  STORNO: 'STORNO',
  CLOSE: 'CLOSE',
};

export const OperationList = (selectedValues) => [
  {
    label: 'Stornózás',
    value: Operation.STORNO,
    disabled:
      selectedValues.docStatus !== DocStatus.OPENED ||
      selectedValues.docLine?.some(
        (line) => line.lineStatus !== DocLineStatus.OPENED || Number(line.cplQty ?? 0) !== 0
      ),
  },
  { label: 'Bezárás', value: Operation.CLOSE, disabled: selectedValues.docStatus !== DocStatus.OPENED },
];

export const DocLineStatusList = [
  { label: 'Nyitott', value: DocLineStatus.OPENED },
  { label: 'Zárt', value: DocLineStatus.CLOSED },
];

export const docRelation = {
  [DocumentType.CustomerOrder]: [DocumentType.Delivery, DocumentType.DownPaymentRequest],
  [DocumentType.SalesQuotation]: [DocumentType.CustomerOrder],
  [DocumentType.DownPaymentRequest]: [DocumentType.DownPayment],
  [DocumentType.GoodsIssue]: [DocumentType.ReturnFromIssue],
  [DocumentType.ProjectIssue]: [DocumentType.ProjectReturn],
  [DocumentType.CooperationIssue]: [DocumentType.CooperationReturn],
  [DocumentType.EmployeeIssue]: [DocumentType.EmployeeReturn],
  [DocumentType.APInvoice]: [DocumentType.PurchaseDelivery],
  [DocumentType.PurchaseQuotation]: [DocumentType.PurchaseOrder],
};

export const docSourceRelation = {
  [DocumentType.Delivery]: [DocumentType.CustomerOrder],
  [DocumentType.ARInvoice]: [DocumentType.Delivery],
  [DocumentType.PurchaseDelivery]: [DocumentType.PurchaseOrder, DocumentType.PurchaseOrderVariant],
  [DocumentType.APInvoice]: [DocumentType.PurchaseDelivery],
  [DocumentType.CustomerOrder]: [DocumentType.SalesQuotation],
  [DocumentType.ReturnFromIssue]: [DocumentType.GoodsIssue],
  [DocumentType.ProjectReturn]: [DocumentType.ProjectIssue],
  [DocumentType.CooperationReturn]: [DocumentType.CooperationIssue],
  [DocumentType.EmployeeReturn]: [DocumentType.EmployeeIssue],
  [DocumentType.PurchaseOrder]: [DocumentType.PurchaseQuotation],
};
